// @owners { team: patients }
import { SIZES, SPACING } from '@alto/design-library-tokens';
import * as React from 'react';
import { View, useWindowDimensions } from 'react-native';
import styled from 'styled-components/native';

// Mirrors apps/web/src/components/Page.tsx's PageBackground, which this was extracted from:
// fills the viewport below the web navbar/footer, with tighter padding once the navbar/footer
// shrink to their smaller (tablet/mobile) heights.
const NAVBAR_HEIGHT = parseInt(SIZES.PAGE.WEB_NAVBAR_HEIGHT.LG, 10);
const FOOTER_HEIGHT_DESKTOP = parseInt(SIZES.PAGE.WEB_FOOTER_HEIGHT.LG, 10);
const FOOTER_HEIGHT_TABLET = parseInt(SIZES.PAGE.WEB_FOOTER_HEIGHT.MD, 10);
const TABLET_BREAKPOINT = 767;
const SM_DESKTOP_BREAKPOINT = 1200;

type LayoutProps = {
  minHeight: number;
  paddingVertical: number;
  paddingHorizontal: number;
};

const layout = ({ minHeight, paddingVertical, paddingHorizontal }: LayoutProps) => `
  width: 100%;
  align-items: center;
  justify-content: center;
  min-height: ${minHeight}px;
  padding: ${paddingVertical}px ${paddingHorizontal}px;
`;

const PlainBackground = styled(View)<LayoutProps>`
  ${layout}
`;

export const CommsVerificationPageBackground = ({ children }: { readonly children: React.ReactNode }) => {
  const { height, width } = useWindowDimensions();
  const isTablet = width <= TABLET_BREAKPOINT;
  const isSmDesktop = width <= SM_DESKTOP_BREAKPOINT;
  const footerHeight = isTablet ? FOOTER_HEIGHT_TABLET : FOOTER_HEIGHT_DESKTOP;
  const layoutProps = {
    minHeight: height - footerHeight - NAVBAR_HEIGHT,
    paddingVertical: isSmDesktop ? SPACING.STATIC.MD.value : SPACING.STATIC.XL.value,
    paddingHorizontal: isSmDesktop ? SPACING.STATIC.MD.value : 0,
  };

  return <PlainBackground {...layoutProps}>{children}</PlainBackground>;
};
